import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssessment, useInstrumentConfig } from '../../contexts/AssessmentContext';
export function ReflectionPanel() {
  const {
    reflection,
    setReflection,
    packConfidence,
    setPackConfidence,
    submit,
    flags,
    locked
  } = useAssessment();
  const config = useInstrumentConfig();
  const {
    questions,
    confidence,
    confidenceLegend
  } = config.reflection;
  const navigate = useNavigate();
  const entries = Object.values(flags);
  const flagged = entries.filter(f => f.kind === 'flag').length;
  const corrected = entries.filter(f => f.kind === 'correction').length;
  const complete = questions.every(q => (reflection[q.key] || '').trim().length > 0) && packConfidence !== null;
  const secondaryLabel = config.id === 'LAW-001' ? 'queries raised' : 'corrections applied';
  const onSubmit = () => {
    if (!complete || locked) return;
    submit();
    navigate('/submitted');
  };
  return <section className="border-t border-slate-200 bg-white" aria-label="Reflection and submission" data-id="element-383" data-mp="1s2l1ff04yzmf">
      <div className="mx-auto max-w-[1600px] px-6 py-8" data-id="element-384" data-mp="e66hypcyikiv">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_320px]" data-id="element-385" data-mp="99od7phmmm6j">
          <div data-id="element-386" data-mp="nxswauklczpu">
            <h2 className="text-base font-semibold text-slate-900" data-id="element-387" data-mp="nyc59ls9kdrq">{config.reflection.heading}</h2>
            <p className="mt-1 text-sm text-slate-500" data-id="element-388" data-mp="iy6cu3e66n8l">{config.reflection.intro}</p>

            <div className="mt-5 space-y-5" data-id="element-389" data-mp="3re9i62ht7ztr">
              {questions.map((q, i) => <div key={q.key} data-id="element-390" data-mp="3mfg4oa2iw8tl" data-mpi={i}>
                  <label htmlFor={q.key} className="block text-sm font-medium text-slate-800" data-id="element-391" data-mp="3mg7wrawwvof4">
                    {i + 1}. {q.label}
                  </label>
                  <textarea id={q.key} rows={4} disabled={locked} value={reflection[q.key] || ''} onChange={e => setReflection({
                ...reflection,
                [q.key]: e.target.value
              })} className="mt-2 w-full rounded-lg border border-slate-300 p-3 text-sm leading-relaxed text-slate-900 focus:border-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-200 disabled:bg-slate-50" data-id="element-392" data-mp="8837iuq4m2u" />
                </div>)}
            </div>

            <fieldset className="mt-8 rounded-lg border border-slate-200 bg-slate-50 p-5" data-id="element-393" data-mp="1sparhnczktgn">
              <legend className="px-1 text-sm font-medium text-slate-900" data-id="element-394" data-mp="1xnc71yb7eand">{confidenceLegend}</legend>
              <div className="mt-3 flex flex-wrap gap-2" data-id="element-395" data-mp="101n98ez6uex6">
                {confidence.map(c => <button key={c.id} type="button" disabled={locked} onClick={() => setPackConfidence(c.id)} className={`rounded-lg border px-4 py-2.5 text-[13px] font-medium transition-colors disabled:opacity-50 ${packConfidence === c.id ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-300 bg-white text-slate-700 hover:border-slate-400'}`} data-id="element-396" data-mp="14zon8lhrbo1s">
                    {c.label}
                  </button>)}
              </div>
            </fieldset>
          </div>

          <aside className="lg:pt-1" data-id="element-397" data-mp="2qgpgetc9ag8c">
            <div className="rounded-lg border border-slate-200 p-5" data-id="element-398" data-mp="2lj62jujh05gx">
              <h3 className="text-sm font-semibold text-slate-900" data-id="element-399" data-mp="2lixm5so52i0z">Your entries</h3>
              <p className="mt-2 font-mono-num text-sm text-slate-700" data-id="element-400" data-mp="2glnrnylw7g6a">
                {flagged} flagged · {corrected} {secondaryLabel}
              </p>
              <p className="mt-2 text-xs leading-relaxed text-slate-500" data-id="element-401" data-mp="27rj35lu8egtx">
                {config.reflection.entriesNote}
              </p>

              <button type="button" onClick={onSubmit} disabled={!complete || locked} className="mt-5 w-full rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-slate-700 disabled:cursor-not-allowed disabled:bg-slate-300" data-id="element-402" data-mp="22u989qo2pcyp">
                {config.reflection.submitLabel}
              </button>
              {!complete && <p className="mt-2 text-xs text-slate-500" data-id="element-403" data-mp="3j6yfakhlr1hj">{config.reflection.incompleteNote}</p>}
            </div>
          </aside>
        </div>
      </div>
    </section>;
}